export const minimumBarWidth = 10;
export const defaultMargin = 100;
export const defaultRightMargin = 24;
